import { MessageProcessor } from '../websocketProcessorTypes'
import { toast } from 'sonner'
import store from '@/redux/store'
import { updateAdvisorMessage } from '@/redux/slices/chatSlice'
import { formatLlmModelDisplay } from '@/utils/llmModelDisplay'

export const commonProcessors: MessageProcessor[] = [
  {
    type: 'provider_switched',
    handler: (data) => {
      const providerDisplayName =
        formatLlmModelDisplay(data.llm_model_name, data.provider) ??
        (data.provider === 'openai' ? 'OpenAI' : 'Claude')

      toast.info(`Switched to ${providerDisplayName} due to service issues`)

      if (data.message_id) {
        const state = store.getState()
        const existing = state.chat.advisorChatMessages.find(
          (msg) => msg.id === data.message_id
        )
        if (existing) {
          store.dispatch(
            updateAdvisorMessage({
              ...existing,
              message: '',
              llm_provider: data.provider,
              llm_model_name: data.llm_model_name,
            })
          )
        }
      }
    },
  },
  {
    type: 'retry_attempt',
    handler: (data) => {
      toast.info(
        `Retrying ${data.provider}... (${data.current_attempt}/${data.max_attempts})`
      )
    },
  },
  {
    type: 'tool_execution',
    handler: (data) => {
      toast.info(
      `Executing ${data.tool_name}... This may take a moment`
    )
    },
  },
]
